var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownwardRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25004 3.75V12.1275L4.59004 8.4675C4.29754 8.175 3.81754 8.175 3.52504 8.4675C3.23254 8.76 3.23254 9.2325 3.52504 9.525L8.46754 14.4675C8.76004 14.76 9.23254 14.76 9.52504 14.4675L14.4675 9.525C14.76 9.2325 14.76 8.76 14.4675 8.4675C14.175 8.175 13.7025 8.175 13.41 8.4675L9.75004 12.1275V3.75C9.75004 3.3375 9.41254 3 9.00004 3C8.58754 3 8.25004 3.3375 8.25004 3.75Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownwardRounded);
export default __webpack_public_path__ + "static/media/ArrowDownwardRounded.09b7714f9faf2b3ca675bb802afc6362.svg";
export { ForwardRef as ReactComponent };